reicoService.$inject = ['$http', 'apiBase', '$q']

function reicoService ($http, apiBase, $q) {
  var endpointPath = apiBase + 'v1/reicofh/reico'
  var newsLetterPath = apiBase + 'v1/reico-newsletter/registration'

  function endpoint (endPath) {
    if (endPath) {
      return endpointPath + '/' + endPath
    } else {
      return endpointPath
    }
  }

  function newsLetterEndpoint (endPath) {
    if (endPath) {
      return newsLetterPath + '/' + endPath
    } else {
      return newsLetterPath
    }
  }

  return {
    getPerformaceHistory: function (dateFrom, dateTo, equityFrom, equityTo) {
      var deferred = $q.defer()

      $http({
        url: endpoint('fundHistory'),
        method: 'GET',
        timeout: deferred.promise,
        cancel: deferred,
        params: {
          dateFrom: dateFrom,
          dateTo: dateTo,
          equityFrom: equityFrom,
          equityTo: equityTo
        }
      }).then(function (result) {
        deferred.resolve(result)
      }, function (error) {
        deferred.reject(error)
      })

      return deferred.promise
    },

    getLastRecord: function () {
      var deferred = $q.defer()
      $http({
        url: endpoint('lastRecord'),
        method: 'GET',
        timeout: deferred.promise,
        cancel: deferred
      }).then(function (result) {
        deferred.resolve(result)
      }, function (error) {
        deferred.reject(error)
      })

      return deferred.promise
    },

    registerNewsletter: function (data) {
      var deferred = $q.defer()

      $http({
        url: newsLetterEndpoint(),
        method: 'POST',
        timeout: deferred.promise,
        cancel: deferred,
        data: data
      }).then(function (result) {
        deferred.resolve(result)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    },

    confirmNewsletter: function (hash) {
      var deferred = $q.defer()

      $http({
        url: newsLetterEndpoint(hash),
        method: 'POST',
        timeout: deferred.promise,
        cancel: deferred
      }).then(function (result) {
        deferred.resolve(result)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    },

    unregisterNewsletter: function (hash) {
      var deferred = $q.defer()

      $http({
        url: newsLetterEndpoint('unsubscribe/' + hash),
        method: 'POST',
        timeout: deferred.promise,
        cancel: deferred
      }).then(function (result) {
        deferred.resolve(result)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }
  }
}

exports.reicoService = reicoService
